//src\pages\CallFlows\components\FlowCanvas\utils\nodeNameContants.ts
export var NODE_NAMES = {
    INBOUND_CALL: "inboundCallNode",
    CALL_DISTRIBUTION_ROUTER: "callDistributionRouterNode",
    AI_AGENT: "aiAgentNode",
    BUYER_ROUTER: "buyerRouterNode",
    BUYER: "buyerNode",
    TIME_ROUTER: "timeRouterNode",
};
